import SendIcon from "@mui/icons-material/Send";
import { Grid, IconButton } from "@mui/material";
import { useState } from "react";
import { getInitials } from "../../../helpers/getInitials";
import isEmpty from "../../../helpers/isEmpty";
import { COMMENT_MAX_LENGTH } from "../../../helpers/inputLimits";
import CommonTextField from "../commonTextField/CommonTextField";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import { CommentorAvatar, CommentorContainer } from "./styles";

type Props = {
  firstName: string;
  lastName: string;
  placeholder: string;
  onSend: (text: string) => Promise<void>;
};

const CommentInputBox = ({
  firstName,
  lastName,
  placeholder,
  onSend,
}: Props) => {
  const [comment, setComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSend = async (text: string) => {
    if (!text) return;
    setComment("");
    setIsLoading(true);
    await onSend(text).finally(() => setIsLoading(false));
  };

  return (
    <CommentorContainer gap={2} container>
      <Grid item xs="auto" sx={{ display: "flex", alignItems: "center" }}>
        <CommentorAvatar>
          {getInitials(`${firstName} ${lastName}`)}
        </CommentorAvatar>
      </Grid>
      <Grid item xs>
        <CommonTextField
          disabled={isLoading}
          placeholder={placeholder}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !isEmpty(comment)) {
              handleSend(comment);
            }
          }}
          minRows={1}
          maxRows={6}
          autoComplete="off"
          fullWidth
          size="small"
          multiline
          inputProps={{ maxLength: COMMENT_MAX_LENGTH }}
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => handleSend(comment)} size="small">
                {isLoading ? (
                  <LoadingSpinner size={20} />
                ) : (
                  <SendIcon fontSize="small" />
                )}
              </IconButton>
            ),
          }}
        />
      </Grid>
    </CommentorContainer>
  );
};

export default CommentInputBox;
